<template>
  <div class="Industry">
    <PageHero :title="industry.title" :lede="industry.lede" />
    <section class="section tint">
      <div class="container">
        <div class="grid cols-2">
          <article class="card company" v-for="c in industry.companies" :key="c.name">
            <div class="logo"><img :src="c.image" :alt="c.name"></div>
            <div class="body">
              <h3><a :href="c.url" target="_blank" rel="noopener">{{ c.name }}</a></h3>
              <p>{{ c.text }}</p>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageHero from '@/components/PageHero'
import industries from '@/data/industries'

export default {
    name: 'Industry',
    components: { PageHero },
    props: { slug: { type: String, required: true } },
    computed: {
        industry() {
            return industries.find((i) => i.name === this.slug)
        }
    },
    // the title option cannot read props, so set it as the route loads
    created() {
        document.title = `${this.industry.title} - Ten Factor Growth`
    }
}
</script>
